<mat-selection-list
  disableRipple="true"
  class="listEvents"
  [formControl]="control"
>
  <h3 matSubheader>
    <div>Events</div>
    <div class="toggle-events-container">
      <mat-checkbox
        (click)="
          $event.stopPropagation(); $event.preventDefault(); toggleAll.emit()
        "
        class="pendo-event-selection-checkbox"
        [checked]="
          control.value?.length === getTotalSubeventsCount() &&
          getTotalSubeventsCount() > 0
        "
        [indeterminate]="false"
        [matTooltip]="eventsToggleTooltip()"
      ></mat-checkbox>
    </div>
  </h3>
  <ng-container *ngFor="let event of events | orderBy: 'label'">
    <div class="event-list-option">
      <mat-expansion-panel
        class="mat-elevation-z0"
        [@.disabled]="true"
        (click)="$event.stopPropagation()"
        [togglePosition]="'before'"
        [expanded]="hasSelectedSubevents(event.value)"
      >
        <mat-expansion-panel-header>
          <mat-panel-title>
            <div class="filter-text">
              <span>{{ event.label }}</span>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="list-container">
          <div class="subevent-selection-list">
            <ng-container
              *ngFor="let subevent of subEvents[event.value] | orderBy: 'label'"
            >
              <mat-list-option
                [class.active]="subevent.selected"
                [class.pendo-subevent-option]="subevent.selected"
                [class.pendo-subevent-option-remove]="!subevent.selected"
                [value]="subevent.value"
                (click)="$event.stopPropagation(); toggleOption.emit(subevent)"
              >
                <div class="subevent-filter-text">
                  <span>{{ subevent.label }}</span>
                </div>
              </mat-list-option>
            </ng-container>
          </div>
        </div>
      </mat-expansion-panel>
    </div>
  </ng-container>
</mat-selection-list>
